const clone = (obj = {}) => ({ ...obj });

export default clone;
